import { cva } from "class-variance-authority";
export { default as Button } from "./Button.vue";
const buttonVariantDefinitions = {
    default: "bg-primary text-primary-foreground hover:bg-primary/90",
    destructive: "bg-destructive text-white hover:bg-destructive/90 focus-visible:ring-destructive/20",
    warning: "bg-amber-100 text-amber-900 border border-amber-300 hover:bg-amber-200",
    info: "bg-sky-100 text-sky-900 border border-sky-300 hover:bg-sky-200",
    success: "bg-emerald-100 text-emerald-900 border border-emerald-300 hover:bg-emerald-200",
    outline: "border border-input bg-primary-foreground shadow-xs hover:bg-secondary/80",
    secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
    ghost: "hover:bg-accent hover:text-accent-foreground",
    link: "text-primary underline-offset-4 hover:underline",
};
const buttonSizeDefinitions = {
    "default": "h-9 px-2 py-2",
    "xs": "h-7 rounded-sm px-2 text-xs",
    "sm": "h-8 rounded-md px-3 text-xs",
    "lg": "h-10 rounded-md px-4 py-2",
    "icon": "size-9",
    "icon-sm": "size-8",
    "icon-lg": "size-10",
};
export const buttonVariants = cva("inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all active:not-aria-[haspopup]:translate-y-px disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive", {
    variants: {
        variant: buttonVariantDefinitions,
        size: buttonSizeDefinitions,
    },
    defaultVariants: {
        variant: "default",
        size: "default",
    },
});
